import _defineProperty from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import { useMemo } from "react";
import Image from "next/image";
import classnames from "classnames";
import { PAYMENT_METHOD_ID } from "@/lib/constants";
import styles from "@/styles/PaymentIconImage.module.scss";
import { jsx as _jsx } from "react/jsx-runtime";
var CreditCardTypes = {
  visa: "visa",
  V: "visa",
  jcb: "jcb",
  J: "jcb",
  mastercard: "master",
  M: "master",
  amex: "amex",
  A: "amex",
  dinersclub: "diners",
  D: "diners",
  all: "credit_card"
};
var DocomoTypes = {
  light: "docomo",
  dark: "docomo_light"
};
var SoftbankTypes = {
  light: "softbank",
  dark: "softbank_light"
};
var AuTypes = {
  light: "au",
  dark: "au_light"
};
var PayPayTypes = {
  light: "paypay_dark",
  dark: "paypay_light"
};
export default function PaymentIconImage(_ref) {
  var _classnames;

  var paymentMethodId = _ref.paymentMethodId,
      cardType = _ref.cardType,
      _ref$onDark = _ref.onDark,
      onDark = _ref$onDark === void 0 ? false : _ref$onDark,
      _ref$large = _ref.large,
      large = _ref$large === void 0 ? false : _ref$large,
      className = _ref.className;
  var type = useMemo(function () {
    var darkOrLight = onDark ? "dark" : "light";

    switch (paymentMethodId) {
      case PAYMENT_METHOD_ID.CREDIT_CARD:
        return CreditCardTypes[cardType];

      case PAYMENT_METHOD_ID.DOCOMO:
        return DocomoTypes[darkOrLight];

      case PAYMENT_METHOD_ID.SOFTBANK:
        return SoftbankTypes[darkOrLight];

      case PAYMENT_METHOD_ID.AU:
        return AuTypes[darkOrLight];

      case PAYMENT_METHOD_ID.PAYPAY:
        return PayPayTypes[darkOrLight];
    }
  }, [paymentMethodId, cardType, onDark]);
  if (!type) return null;
  var iconClass = useMemo(function () {
    switch (paymentMethodId) {
      case PAYMENT_METHOD_ID.CREDIT_CARD:
        return type;

      case PAYMENT_METHOD_ID.DOCOMO:
        return "docomo";

      case PAYMENT_METHOD_ID.SOFTBANK:
        return "softbank";

      case PAYMENT_METHOD_ID.AU:
        return "au";

      case PAYMENT_METHOD_ID.PAYPAY:
        return "paypay";
    }
  }, [paymentMethodId, type]);
  return /*#__PURE__*/_jsx("div", {
    className: classnames(styles.imageWrapper, styles[iconClass], (_classnames = {}, _defineProperty(_classnames, styles.large, large), _defineProperty(_classnames, className, !!className), _classnames)),
    children: /*#__PURE__*/_jsx(Image, {
      src: "/images/payment_icon/payment_icon_".concat(type, ".png"),
      alt: type,
      layout: "fill",
      objectFit: "contain"
    })
  });
}